import {
    ACTION_TYPES,
    EmailVerificationActions,
} from '../../actions/email-verification/EmailVerificationActions';
import { API_STATUSES } from '../../constants';
import { ImmutableEmailVerificationState } from '../../contexts/email-verification/EmailVerificationContext';

const EmailVerificationReducer = (
    state: ImmutableEmailVerificationState,
    action: EmailVerificationActions
): ImmutableEmailVerificationState => {
    switch (action.type) {
        case ACTION_TYPES.EMAIL_VERIFICATION_UPDATE_EMAIL_FIELD:
            return state.mergeIn(
                [action.payload.fieldName],
                action.payload.data
            );
        case ACTION_TYPES.EMAIL_VERIFICATION_SET_MODE:
            return state.set('mode', action.payload.mode);
        case ACTION_TYPES.CHANGE_EMAIL_SUBMIT_IN_PROGRESS:
            return state
                .setIn(['changeEmailSubmit', 'status'], action.payload.status)
                .setIn(['changeEmailSubmit', 'error'], null)
                .setIn(['changeEmailSubmit', 'showError'], false);
        case ACTION_TYPES.CHANGE_EMAIL_SUBMIT_SUCCESS:
            return state
                .setIn(['changeEmailSubmit', 'status'], action.payload.status)
                .setIn(['changeEmailSubmit', 'error'], null)
                .setIn(['changeEmailSubmit', 'showError'], false);
        case ACTION_TYPES.CHANGE_EMAIL_SUBMIT_ERROR:
            return state
                .setIn(['changeEmailSubmit', 'status'], action.payload.status)
                .setIn(['changeEmailSubmit', 'error'], action.payload.error)
                .setIn(['changeEmailSubmit', 'showError'], true);
        case ACTION_TYPES.FETCH_STATUS_SUBMIT_IN_PROGRESS:
            return state
                .setIn(['evStatusAPISubmit', 'status'], action.payload.status)
                .setIn(['evStatusAPISubmit', 'error'], null);
        case ACTION_TYPES.FETCH_STATUS_SUBMIT_SUCCESS:
            return state
                .setIn(['evStatusAPISubmit', 'status'], API_STATUSES.SUCCESS)
                .set('evStatus', action.payload);
        case ACTION_TYPES.FETCH_STATUS_SUBMIT_ERROR:
            return state
                .setIn(['evStatusAPISubmit', 'status'], action.payload.status)
                .setIn(['evStatusAPISubmit', 'error'], action.payload.error);
    }
};

export default EmailVerificationReducer;
